<template>
    <div class="field-panel-divider"></div>
</template>
<script>
export default {
    name:"FieldPanelDivider"
}
</script>
<style lang="scss">
.field-panel-divider {
    @apply m-auto bg-gray-alt2 h-10;
    width:1px;
}
</style>